import React from 'react'

export default function CloseIcon() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="white" />
            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#ECEBF7" />
            <path fillRule="evenodd" clipRule="evenodd" d="M10.3444 10.3431C10.7907 9.89683 11.5143 9.89683 11.9606 10.3431L21.6581 20.0406C22.1044 20.4869 22.1044 21.2105 21.6581 21.6569C21.2117 22.1032 20.4881 22.1032 20.0418 21.6569L10.3444 11.9594C9.89804 11.5131 9.89804 10.7895 10.3444 10.3431Z" fill="#B1AEC7" />
            <path fillRule="evenodd" clipRule="evenodd" d="M10.3444 21.6569C9.89804 21.2105 9.89804 20.4869 10.3444 20.0406L20.0418 10.3431C20.4881 9.89683 21.2117 9.89683 21.6581 10.3431C22.1044 10.7895 22.1044 11.5131 21.6581 11.9594L11.9606 21.6569C11.5143 22.1032 10.7907 22.1032 10.3444 21.6569Z" fill="#B1AEC7" />
        </svg>
    )
}
